import React from 'react';
import Postgraduate from './postgraduateComponent';
import Undergraduate from './undergraduateComponent';
import SingleDegree from './singleDegreeComponent';

class Degrees extends React.Component {
  constructor() {
    super();

    this.createAccordion = this.createAccordion.bind(this);
  }

  createAccordion(item, i) {
    return <SingleDegree data={item} key={i} dispatchReducer={this.props.dispatchReducer} />;
  }

  render() {
    let { data } = this.props;

    return <div id="degrees-wrap" className="degrees-wrap clearfix">

      <Postgraduate data={data.postgraduate}
                    createAccordion={this.createAccordion} />

      <Undergraduate data={data.undergraduate}
                     createAccordion={this.createAccordion} />

    </div>;
  }
}

Degrees.propTYpes = {
  data:            React.PropTypes.object.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default Degrees;
